import { render, staticRenderFns } from "./NotasEnfermeria.vue?vue&type=template&id=3f747ebd&scoped=true"
import script from "./NotasEnfermeria.vue?vue&type=script&lang=js"
export * from "./NotasEnfermeria.vue?vue&type=script&lang=js"
import style0 from "./NotasEnfermeria.vue?vue&type=style&index=0&id=3f747ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f747ebd",
  null
  
)

export default component.exports